import { ConditionalRendererProps } from "utils/types";
import { Fragment, PropsWithChildren, ReactElement } from "react";
import styles from "./styles.module.scss";

export function ConditionalRenderer({
  condition,
  children,
  variant,
  errorMessage,
  isDisplay,
}: PropsWithChildren<ConditionalRendererProps>): ReactElement {
  if (isDisplay) {
    return (
      <div className={styles[condition ? "display" : "hide"]}>{children}</div>
    );
  }

  if (condition) {
    return <Fragment>{children}</Fragment>;
  }

  if (variant === "error-msg") {
    return (
      <div className={styles["error-container"]}>
        <h1 className={styles.error}>{errorMessage}</h1>
      </div>
    );
  }

  return <Fragment></Fragment>;
}
